import { registerComponent, createMessage, getComponentConfig } from "helpers";

registerComponent(
  "wyatt-share",
  class WyattShare extends HTMLElement {
    constructor() {
      super();

      this.config = getComponentConfig(this);
      this.button = this.querySelector("button");
      this.button.addEventListener("click", this.copyToClipboard.bind(this));
    }

    async copyToClipboard() {
      await window.navigator.clipboard.writeText(this.config.url);

      createMessage(this.config.successMessage, { type: "success" });
      this.close();
    }
  }
);
